import React, {Component} from 'react'
import {observer} from 'mobx-react'

import SpanLink from 'lib/control/SpanLink'
import Modal from 'lib/struct/Modal'

import ParamsByFeaturesBuilder from './ParamsByFeaturesBuilder'
import CustomParamTagSourceField from '../../../../struct/CustomParamTagSourceField'
import TagSourceField from '../../../../struct/TagSourceField'
import Mono from '../../../../struct/Mono'
import OfferFieldValueSourceSelect from '../OfferFieldValueSourceSelect'

import Icon from 'lib/struct/icon/Icon';

import * as UnitMode from '../../../../../constant/OfferCustomParamUnitMode'

import styles from './OfferCustomParamsSettings.less'

@observer export default class OfferCustomParamsSettings extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        /** @type {Array<OfferCustomParam>} */
        const custom_params = this.props.custom_params.sort((a,b)=> (a.sort > b.sort) ? 1 : (a.sort < b.sort ? -1 : 0))
        const {addCustomParam} = this.props

        return (
            <div>
                {
                    custom_params.map(custom_param => (
                        <div key={custom_param._unique_key}>
                            <CustomParamTagSourceField
                                label="<param>"
                                tag="param"
                                custom_param={custom_param}
                                with_unit={context.isWithUnit(custom_param.value_source)}
                                onNameChange={this.onNameChange}
                                onUnitModeChange={this.onUnitModeChange}
                                onCustomUnitChange={this.onCustomUnitChange}
                                onParamDelete={this.onParamDelete}
                                state={context.form_state}
                            >
                                <OfferFieldValueSourceSelect
                                    context={context}
                                    value_source={custom_param.value_source}
                                    field="custom_param"
                                    onChange={value_source => {
                                        const feature_name = context.getFeatureName(value_source)
                                        if (feature_name) {
                                            custom_param.name = feature_name
                                        }

                                        custom_param.unit_mode = context.isWithUnit(value_source)
                                            ? UnitMode.FROM_VALUE
                                            : UnitMode.CUSTOM
                                    }}
                                />
                            </CustomParamTagSourceField>
                        </div>
                    ))
                }

                <TagSourceField contentClass={styles['param-block']}>
                    <Icon name="add"/> Добавить характеристику <Mono
                    className={styles['param-tag']}>{'<param>'}</Mono> <SpanLink
                    onClick={() => addCustomParam()}>одну</SpanLink>
                    <span className={styles['param-buttons-separator']}>или</span>
                    <SpanLink onClick={() => context.openParamsByFeaturesBuilder()}>выбрать характеристики
                        товаров</SpanLink>
                </TagSourceField>

                <Modal
                    isOpen={context.isParamsByFeaturesBuilderOpened()}
                    onClose={() => context.closeParamsByFeaturesBuilder()}
                >
                    <ParamsByFeaturesBuilder
                        context={context}
                        addCustomParam={addCustomParam}
                    />
                </Modal>
            </div>
        )
    }

    /**
     * @param {OfferCustomParam} custom_param
     * @param name
     */
    onNameChange = (custom_param, name) => {
        custom_param.name = name
    }

    /**
     * @param {OfferCustomParam} custom_param
     * @param unit_mode
     */
    onUnitModeChange = (custom_param, unit_mode) => {
        custom_param.unit_mode = unit_mode
    }

    /**
     * @param {OfferCustomParam} custom_param
     * @param custom_unit
     */
    onCustomUnitChange = (custom_param, custom_unit) => {
        custom_param.custom_unit = custom_unit
    }

    /**
     * @param {OfferCustomParam} custom_param
     */
    onParamDelete = (custom_param) => {
        const {deleteCustomParam} = this.props

        deleteCustomParam(custom_param)
    }
}